import { Dispatch } from 'redux';
import {
  SERVER_ERROR,
  INVALID_ERROR,
  MISSING_ERROR,
  CLEAR_ERROR,
  PERSONAL_NUMBER,
} from '~/actions/actionTypes';
import { getErrorMessage, IErrorMessages } from '~/services/ErrorMessageService';
import { ISignupState, IState } from '~/sharedInterfaces/IState';
import { ECardRequiredComponents } from '~/sharedInterfaces/SharedEnums';
import { ICardSignup } from '~/sharedInterfaces/SharedInterfaces';

export const setServerError = (value: string) => ({
  type: SERVER_ERROR,
  payload: value,
});

export const setMissingError = (componentName: string, message: string) => ({
  type: MISSING_ERROR,
  payload: {
    message,
    componentName,
  },
});

export const setInvalidError = (componentName: string, message: string) => ({
  type: INVALID_ERROR,
  payload: {
    message,
    componentName,
  },
});

export const displayErrorMessage = (personalNumber: string) => {
  return (dispatch: Dispatch, getState: () => IState) => {
    const { signup, widgetContext } = getState();
    if (widgetContext.settings.widgetType === 'loan') {
      Object.keys(signup).forEach((componentKey) => {
        if (signup[componentKey as keyof ISignupState]) dispatch(setMissingError(componentKey, ''));
        else {
          const { missing } = getErrorMessage(
            widgetContext.locale,
            componentKey as keyof IErrorMessages
          );
          dispatch(setMissingError(componentKey, missing));
        }
      });

      // We have to check for empty string because personalNumber will be possibly undefined...
      // ... if it's the signup request that triggered the call to this function.
      // TODO: Possibly refactor this to be consistent with the loop above.
      // We can remove this if personal number becomes optional in the backend.
      if (personalNumber === '') {
        const { missing } = getErrorMessage(widgetContext.locale, PERSONAL_NUMBER);
        dispatch(setMissingError(PERSONAL_NUMBER, missing));
      }
    } else if (widgetContext.settings.widgetType === 'card') {
      Object.keys(signup).forEach((componentKey) => {
        if ((signup as ICardSignup)[componentKey as keyof ICardSignup])
          dispatch(setMissingError(componentKey, ''));
        else {
          const { missing } = getErrorMessage(
            widgetContext.locale,
            componentKey as keyof IErrorMessages
          );
          const componentName = componentKey as keyof ICardSignup;
          if (
            ECardRequiredComponents[componentName] &&
            widgetContext.pages[widgetContext.currentPage][componentName]
          ) {
            dispatch(setMissingError(componentKey, missing));
          }
        }
      });
    }
  };
};

export const clearAllErrors = () => {
  return (dispatch: Dispatch, getState: () => IState) => {
    const { error } = getState();
    Object.keys(error).forEach((errorKey) => {
      dispatch({ type: CLEAR_ERROR, payload: { errorKey } });
    });
  };
};
